module.exports = __webpack_public_path__ + "img/Group 12.4ae2463.svg";